export function productPage() {
    return {
        $el: {},
        init() {
            var _a;
            const product = JSON.parse(this.$el.closest('[data-product]').dataset.product);
            (_a = window.gtag) === null || _a === void 0 ? void 0 : _a.call(window, 'event', 'view_item', {
                currency: "NOK",
                value: product.price,
                items: [
                    {
                        item_id: product.sku,
                        item_name: product.title,
                        currency: "NOK",
                        item_category: product.categorySlug,
                        price: product.price,
                    }
                ]
            });
        },
    };
}
